import type { AccountUser } from '@/features/account';
import type { DestinationPrices } from '@/features/searchForm/destination';
import type { SearchFormCriteria } from '@/widgets/searchForm';

export interface SerpPageProps {
  modelValue?: SearchFormCriteria | null;
  user?: AccountUser | null;
  accountUrl?: string;
  prices?: DestinationPrices;
  isVisibleRoomButton?: boolean;
  departureDisabled?: boolean;
  destinationDisabled?: boolean;
}

export const EMPTY_CRITERIA: SearchFormCriteria = {
  fromCity: null,
  destination: null,
  nights: null,
  dateRange: null,
  tourists: null,
};
